export default __webpack_public_path__ + "static/Pubertad-d21393239b7914c061c83df8c2999451.png";